(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["filters"] && !Shopify.designMode) return;
  try {
    (function () {
  if (window.__uconFiltersInit) return;
  window.__uconFiltersInit = true;

  // ── Desktop dropdown open/close (delegated so it survives AJAX swaps) ──
  function closeAllDropdowns(except) {
    document.querySelectorAll('[data-filter-dropdown]').forEach(function (dd) {
      if (dd === except) return;
      var trigger = dd.querySelector('.fd-dropdown__trigger');
      var panel = dd.querySelector('.fd-dropdown__panel');
      if (trigger) trigger.setAttribute('aria-expanded', 'false');
      if (panel) panel.hidden = true;
    });
  }

  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('.fd-dropdown__trigger');
    if (trigger) {
      var dd = trigger.closest('[data-filter-dropdown]');
      var panel = dd && dd.querySelector('.fd-dropdown__panel');
      var isOpen = trigger.getAttribute('aria-expanded') === 'true';
      closeAllDropdowns(dd);
      trigger.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
      if (panel) panel.hidden = isOpen;
      return;
    }
    if (!e.target.closest('[data-filter-dropdown]')) closeAllDropdowns();
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeAllDropdowns();
  });

  // ── Mobile drawer: stage selections, commit on "Apply filters" ──
  // Use the page's current params as the baseline and toggle from there.
  var pending = null;

  function seedPending() { pending = new URLSearchParams(window.location.search); }

  function navigate(url) {
    if (window.__collectionFilterNavigate) window.__collectionFilterNavigate(url, true);
    else window.location.href = url;
  }

  // The single (param,value) a Shopify filter link toggles = the difference
  // between its href params and the current page params.
  function togglePairOf(link) {
    var hrefParams = new URL(link.href, window.location.origin).searchParams;
    var cur = [];
    new URLSearchParams(window.location.search).forEach(function (v, k) { cur.push([k, v]); });
    var pair = null;
    hrefParams.forEach(function (v, k) {
      var idx = -1;
      for (var i = 0; i < cur.length; i++) {
        if (cur[i][0] === k && cur[i][1] === v) { idx = i; break; }
      }
      if (idx === -1) { if (!pair) pair = [k, v]; } else { cur.splice(idx, 1); }
    });
    if (!pair && cur.length) pair = cur[0];
    return pair;
  }

  function applyPair(key, value, add) {
    var vals = pending.getAll(key);
    if (add) { pending.append(key, value); return; }
    var i = vals.indexOf(value);
    if (i !== -1) { vals.splice(i, 1); pending.delete(key); vals.forEach(function (x) { pending.append(key, x); }); }
  }

  function refreshApplyCount() {
    var badge = document.querySelector('.fm__apply-count');
    if (!badge) return;
    var n = 0;
    if (pending) pending.forEach(function (v, k) { if (k.indexOf('filter.') === 0) n++; });
    badge.textContent = n > 0 ? n : '';
  }

  // The drawer body ships in a <template> (see the comment above .filters-mobile).
  // Stamp it into the panel next to this trigger; its colour boxes are filled with
  // clones of the desktop dropdown's links, renamed to the drawer's classes. A no-op
  // once stamped: the first open moves the panel to <body>, out of .filters-mobile,
  // and an AJAX swap of the filter bar brings a fresh panel with a fresh template.
  function stampDrawer(trigger) {
    var host = trigger.closest('.filters-mobile');
    var tpl = host && host.querySelector('template[data-fm-template]');
    if (!tpl) return;
    var body = document.importNode(tpl.content, true);
    var sources = host.parentNode.querySelectorAll('[data-fd-colors]');
    body.querySelectorAll('[data-fm-colors]').forEach(function (box) {
      var param = box.getAttribute('data-fm-colors');
      var src = null;
      for (var i = 0; i < sources.length && !src; i++) {
        if (sources[i].getAttribute('data-fd-colors') === param) src = sources[i];
      }
      if (!src) return;
      src.querySelectorAll('.fd-dropdown__color').forEach(function (link) {
        var copy = link.cloneNode(true);
        copy.className = copy.className.replace('fd-dropdown__color', 'fm__color');
        var swatch = copy.querySelector('.fd-dropdown__color-swatch');
        if (swatch) swatch.className = 'fm__color-swatch';
        box.appendChild(copy);
      });
    });
    tpl.replaceWith(body);
  }

  // Stamp on the press itself so the work is done before the click lands.
  document.addEventListener('pointerdown', function (e) {
    var trigger = e.target.closest && e.target.closest('.filters-mobile__trigger');
    if (trigger) stampDrawer(trigger);
  }, { passive: true });

  // Open the drawer (stamping first for a keyboard press, which has no pointerdown),
  // then re-seed the staged state from the page's current params.
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('.filters-mobile__trigger');
    if (!trigger) return;
    stampDrawer(trigger);
    if (window.__openDrawer) window.__openDrawer('filter-drawer');
    seedPending();
    refreshApplyCount();
  });

  document.addEventListener('click', function (e) {
    // Clear all -> commit empty immediately.
    var clear = e.target.closest('.fm__clear-btn');
    if (clear) {
      e.preventDefault();
      window.__closeDrawer('filter-drawer');
      navigate(clear.getAttribute('href'));
      return;
    }

    // Apply -> build URL from staged params and commit.
    var apply = e.target.closest('.fm__apply-btn');
    if (apply) {
      e.preventDefault();
      if (!pending) seedPending();
      var base = apply.getAttribute('data-base-url');
      var qs = pending.toString();
      window.__closeDrawer('filter-drawer');
      navigate(qs ? base + '?' + qs : base);
      return;
    }

    // Staged filter taps (do not navigate).
    var link = e.target.closest('.fm__check, .fm__color, .fm__size');
    if (!link || !link.closest('.fm')) return;
    e.preventDefault();
    if (!pending) seedPending();

    if (link.hasAttribute('data-price')) {
      // Single price range: clear then set (replace semantics).
      var gte = link.getAttribute('data-price-gte-param');
      var lte = link.getAttribute('data-price-lte-param');
      var min = link.getAttribute('data-price-min');
      var max = link.getAttribute('data-price-max');
      var wasActive = link.classList.contains('is-active');
      if (gte) pending.delete(gte);
      if (lte) pending.delete(lte);
      var group = link.closest('.fm__checks') || link.closest('.fm__section');
      if (group) group.querySelectorAll('[data-price]').forEach(function (b) { b.classList.remove('is-active'); });
      if (!wasActive) {
        if (gte && min && min !== '0') pending.set(gte, min);
        if (lte && max && max !== '0') pending.set(lte, max);
        link.classList.add('is-active');
      }
    } else if (link.hasAttribute('data-single-select')) {
      // Single-select (size): replace any current value of this param with this one.
      var spair = togglePairOf(link);
      if (spair) {
        var sOn = !link.classList.contains('is-active');
        var grp = link.closest('.fm__sizes') || link.closest('.fm__section');
        if (grp) grp.querySelectorAll('[data-single-select]').forEach(function (b) { b.classList.remove('is-active'); });
        if (sOn) { pending.set(spair[0], spair[1]); link.classList.add('is-active'); }
        else { pending.delete(spair[0]); }
      }
    } else {
      var pair = togglePairOf(link);
      if (pair) {
        var turningOn = !link.classList.contains('is-active');
        applyPair(pair[0], pair[1], turningOn);
        link.classList.toggle('is-active', turningOn);
        var x = link.querySelector('.fm__check-remove');
        if (x) x.hidden = !turningOn;
      }
    }
    refreshApplyCount();
  });
})();
  } catch(e) { console.error(e); }
})();

})();
